import { ReactComponent as CheckBoxIconUnstyled } from './check-box.svg'
const CheckBoxIcon = ({ color = 'transparent' }) => (
    <CheckBoxIconUnstyled color={color} style={{ overflow: 'visible' }} />
)
export default CheckBoxIcon
